module.exports = function getResource(label) {
    const resources = {
        accountClosed: 'Compte fermé avec succès',
        loggedOut: 'Vous êtes maintenant déconnecté.',
        message: 'Si vous avez des questions concernant la fermeture de votre compte, veuillez communiquer avec notre équipe du service à la clientèle au 1 877 SEPHORA (1 877 737-4672) ou clavarder avec nos représentant(e)s.'
    };
    return resources[label];
};

